import { useEffect, useRef } from 'react';
import { type EventConfig, getPusherEventKey, usePusher } from './pusher-context';

export function usePusherEvents(eventConfigs: EventConfig[]) {
  const { addEventConfig, removeEventConfig } = usePusher();
  const prevEventConfigsRef = useRef<Map<string, EventConfig>>(new Map());

  useEffect(() => {
    const prevEventConfigs = prevEventConfigsRef.current;
    const currentConfigsMap = new Map<string, EventConfig>();

    const configsToAdd: EventConfig[] = [];
    for (const config of eventConfigs) {
      const key = getPusherEventKey(config);
      currentConfigsMap.set(key, config);

      // If the key does not exist in prevEventConfigs, it is a new config
      if (!prevEventConfigs.has(key)) {
        configsToAdd.push(config);
      }
    }

    // Determine the configs to remove
    const configsToRemove: EventConfig[] = [];
    prevEventConfigs.forEach((config, key) => {
      if (!currentConfigsMap.has(key)) {
        configsToRemove.push(config);
      }
    });

    configsToAdd.forEach(addEventConfig);
    configsToRemove.forEach(removeEventConfig);

    prevEventConfigsRef.current = currentConfigsMap;
  }, [eventConfigs, addEventConfig, removeEventConfig]);
}
